import { Field, Form, FormikProvider, useFormik } from 'formik';
import React from 'react'
import * as bie from "react-bootstrap";
import { useSelector } from "react-redux";

export default function FinalInspection() {
    const instName = sessionStorage.getItem('user_name');
    const Userid = sessionStorage.getItem('user_id');
    const NocServicesOptions = useSelector((state) => state?.commonMastersReducer?.nocservices);

    const InstitutionFormik = useFormik({
        initialValues: {
            instName: instName,
            collcode: Userid,
            inspdate: "",
            remarks: "",
            inspby: "",
            inspto: "",
            inspdoc: "",
        },
        enableReinitialize: true,
        // validationSchema: validationSchema,
        validateOnBlur: true,
        validateOnChange: false,
        onSubmit: (values) => {
            // submitStdFcltRatio(values)
        }
    });
    return (
        <>
            <div className="faculty-form-wrapper">
                <div className="faculty-card">
                    <FormikProvider value={InstitutionFormik}>
                        <Form onSubmit={InstitutionFormik.handleSubmit}
                            onChange={InstitutionFormik.handleChange}
                        >

                            <h5 className="mb-3 innerheader-new"><span>Final Inspection</span></h5>
                            <bie.Row className="mb-3">




                                <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-2">
                                    <label>Name of Institution
                                    </label>
                                    <Field type='text'
                                        name="instName"
                                        className="form-control"
                                        value={instName || ''}
                                        disabled

                                    />

                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-2">
                                    <label>College Code
                                    </label>
                                    <Field type='text'
                                        name="collcode"
                                        className="form-control"
                                        value={Userid || ''}
                                        disabled

                                    />

                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-2">
                                    <label>Inspected By
                                    </label>
                                    <Field type='text'
                                        name="inspby"
                                        className="form-control"
                                        // value={instName || ''}
                                        disabled

                                    />

                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-2">
                                    <label>Inspected to
                                    </label>
                                    <Field as='select'
                                        name="inspto"
                                        className="form-control select-input"


                                    >
                                        <option value="">Select</option>
                                        <option value="Programme / Intake Changes">Programme / Intake Changes</option>
                                        <option value="Shifting of the Institution">Shifting of the Institution</option>
                                        <option value="Change of Institution Name">Change of Institution Name</option>
                                        <option value="Merger of Institutions">Merger of Institutions</option>
                                        <option value="Conversion of the Institution">Conversion of the Institution</option>
                                        <option value="Closure of Institution">Closure of Institution</option>
                                        <option value="Trust / Society Name Changeivate">Trust / Society Name Change</option>


                                    </Field>

                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-2">
                                    <label>Inspected Date</label>

                                    <Field type='date'
                                        name="inspdate"
                                        className="form-control"

                                    />

                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-2">
                                    <label>Upload Inspected Document</label>

                                    <Field type='file'
                                        name="inspdoc"
                                        className="form-control"

                                    />

                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className="mb-2">
                                    <label>Enter Remarks</label>
                                    <Field
                                        as="textarea"
                                        name="remarks"
                                        className="form-control textarea-custom"
                                        placeholder="Enter remarks"
                                    />

                                </bie.Col>

                            </bie.Row>
                            <div className="text-end mt-3">
                                <button type="submit" className="btn btn-primary">
                                    Submit
                                </button>
                            </div>
                        </Form>
                    </FormikProvider>

                </div>
            </div >


        </>)
}
